const Plans = {
  PAY_AS_YOU_GO: 'pay_as_you_go',
  SCALE: 'scale',
  GROW: 'grow',
};

export default Plans;
